'use client';

import styled from 'styled-components';
import { COLORS } from '@/constants';
import { Card } from '@mui/material';

export const BrokerCardContainer = styled(Card).attrs({
  elevation: 0,
})`
  border-radius: 8px;
  border: 1px solid ${COLORS['neutral/200']};
  background-color: ${COLORS.white};
  display: flex;
  flex-direction: column;
  box-shadow: none;
  height: 100%;
`;

export const LogoContainer = styled.div`
  width: 138px;
  height: 92px;
  min-width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background-color: ${COLORS['neutral/100']};
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 480px) {
    width: 100px;
    height: 68px;
  }
`;

export const StatsContainer = styled.div`
  display: flex;
  gap: 42px;
  margin-top: 4px;

  @media (max-width: 480px) {
    gap: 20px;
  }
`;

export const StatItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const StatValue = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 130%;
  color: ${COLORS['neutral/700']};

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const StatLabel = styled.div`
  font-size: 11px;
  line-height: 125%;
  color: ${COLORS['neutral/600']};
`;

export const ContactInfo = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  
  svg {
    margin-top: 2px;
    flex-shrink: 0;
    color: ${COLORS['brown/400']};
    
    path {
      stroke: ${COLORS['brown/400']} !important;
    }
  }
`;

